<script setup>
import GridTextBox from '@zyro-inc/site-modules/components/elements/text-box/GridTextBox.vue';

defineProps({
	data: {
		type: Object,
		required: true,
	},
});
</script>

<template>
	<GridTextBox
		:text-align="data.settings.styles.text"
		:text-align-mobile="data.settings.styles['m-text']"
		:background-color="data.backgroundColor"
		:content="data.content"
	/>
</template>
